import { parseBoolean } from '@chatwoot/utils';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  BRAND_PRIMARY_COLOR: brandPrimaryColor,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  SSO_LOGIN_ENABLED: ssoLoginEnabled,
  CUSTOM_META_DESCRIPTION: customMetaDescription,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  // Login page customization
  LOGIN_BACKGROUND_IMAGE: loginBackgroundImage,
  LOGIN_PAGE_TITLE: loginPageTitle,
  LOGIN_PAGE_DESCRIPTION: loginPageDescription,
  LOGIN_OVERLAY_COLOR: loginOverlayColor,
  LOGIN_OVERLAY_OPACITY: loginOverlayOpacity,
  LOGIN_TITLE_COLOR: loginTitleColor,
  LOGIN_DESCRIPTION_COLOR: loginDescriptionColor,
  LOGIN_PAGE_FEATURES: loginPageFeatures,
  LOGIN_FORM_POSITION: loginFormPosition,
} = window.globalConfig || {};

// Parse login features from JSON string
function parseLoginFeatures(featuresStr) {
  if (!featuresStr) return null;
  try {
    return JSON.parse(featuresStr);
  } catch {
    return null;
  }
}

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  brandPrimaryColor,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  isSsoEnabled: parseBoolean(ssoLoginEnabled),
  customMetaDescription,
  // Login page customization
  loginBackgroundImage,
  loginPageTitle,
  loginPageDescription,
  loginOverlayColor,
  loginOverlayOpacity: parseInt(loginOverlayOpacity, 10) || 80,
  loginTitleColor,
  loginDescriptionColor,
  loginPageFeatures: parseLoginFeatures(loginPageFeatures),
  loginFormPosition,
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
